exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid.flex {\n  display: flex;\n}\n\n.grid.flex>div {\n  flex: 1;\n  padding: 0 1.5rem;\n}\n\n.grid.flex>div:first-child {\n  padding-left: 0;\n}\n\n.grid.flex>div:last-child {\n  padding-right: 0;\n}\n\n.grid.list-item {\n  display: table;\n  margin: 0 -0.75rem;\n}\n\n.grid.list-item>div {\n  display: table-cell;\n  padding: .5rem .75rem;\n  line-height: 2rem;\n}\n\n.grid.list-item>div:first-child {\n  width: 100%;\n}\n\n.grid.list-item>div>div {\n  margin-bottom: .8rem;\n  word-break: break-all;\n}\n\n.grid.list-item small {\n  font-size: 1.75rem;\n}\n\n.grid.list-item big {\n  font-size: 3rem;\n  line-height: 4rem;\n}\n\n", ""]);

// exports
